import React from 'react';
import withLazyLoad from 'utils/withLazyLoad';
import withPid from 'utils/withPid';
import Slider from 'components/Slider';

import Market from '../../components/Market';
import './style.scss';

const ITradeUP: React.FC = () => {
    return (
        <>
            <Slider className="banner itradeup-root">
                <div className="performance">
                    <div className="site-main" data-animation="a-flyTopIn">
                        <h5 className="brand">itradeup</h5>
                        <h3>Share Your Performance on Social Media </h3>
                        <p>Investment performance is available for sharing on Twitter and Instagram</p>
                    </div>
                </div>
                <div className="real-time">
                    <div className="site-main" data-animation="a-flyTopIn">
                        <h5 className="brand">itradeup</h5>
                        <h3>Free, real-time</h3>
                        <p>stock quotes without delays</p>
                    </div>
                </div>
                <div className="no-min">
                    <div className="site-main" data-animation="a-flyTopIn">
                        <h5 className="brand">itradeup</h5>
                        <h3>No minimum</h3>
                        <p>deposit requirement</p>
                    </div>
                </div>
            </Slider>
            <Market />
        </>
    );
};

export default withLazyLoad(withPid('brand')(ITradeUP));
